<template>
  <can I="list" a="OpportunityApplication">
    <div class="candidate profile applications">
      <v-toolbar class="transparent elevation-0 my-3">
        <div class="headline">Applications</div>
      </v-toolbar>

      <v-card class="mt-2">
        <v-card-title v-if="total <= 0">
          Candidate has no applications
        </v-card-title>

        <List
          v-else
          :applications="active"
          :loading="loading"
          :total-items="total"
          @paginate="search"
        />
      </v-card>
    </div>
  </can>
</template>

<script>
// Components
import List from '@/components/applications/List'

// Helpers
import { mapState } from 'vuex'

export default {
  components: { List },

  created() {
    this.$store.dispatch('admin/applications/search', {
      opportunity: null,
      filters: { profiles: this.profile.id },
    })
  },

  props: { profile: { type: Object, required: true } },

  computed: {
    ...mapState('admin/applications', ['active', 'loading', 'total', 'page', 'rowsPerPage']),
  },

  methods: {
    search(e) {
      this.$store.dispatch('admin/applications/search', {
        opportunity: null,
        ...Object.assign(
          { filters: { profiles: this.profile.id } },
          typeof e === 'KeyboardEvent' ? {} : e
        ),
      })
    },
  },
}
</script>
